import React, { useEffect, useState } from "react";
import "./admin_courses.css";


import Sidebar from "../../Components/3rd page(Dashboard)/sidebar";

import AOS from "aos";
import "aos/dist/aos.css";

import {
  FiPlus,
  FiSearch,
  FiChevronDown,
  FiEdit2,
  FiTrash2,
  FiUsers,
} from "react-icons/fi";

export default function AdminCourses() {
  const API = "http://localhost:3001/courses";
  const [showModal, setShowModal] = useState(false);
const [editingId, setEditingId] = useState(null);

const emptyCourse = {
  title: "",
  category: "",
  image: "",
  description: "",
  price: "",
  rating: "",
  students: "",
  duration: "",
  instructor: "",
  status: "Published"
};

const [courseForm, setCourseForm] = useState(emptyCourse);
const handleChange = (e) => {
    setCourseForm({
        ...courseForm,
        [e.target.name]: e.target.value
    });
};
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      mirror: false,
      offset: 0,
    });
  }, []);

  // const [editingCourse, setEditingCourse] = useState(null);
  // const editCourse = (course) => {
  //   const title = prompt("Edit Course Name", course.title);

  //   if (!title) return;

  //   setCourses((prev) =>
  //     prev.map((c) => (c.id === course.id ? { ...c, title } : c)),
  //   );
  // };

  const [courses, setCourses] = useState([]);
  useEffect(() => {
  fetchCourses();

  AOS.init({
    duration: 900,
    easing: "ease-out-cubic",
    once: true,
    mirror: false,
    offset: 0,
  });
}, []);

const fetchCourses = async () => {
  try {
    const res = await fetch(API);
    const data = await res.json();
    setCourses(data);
  } catch (err) {
    console.error(err);
  }
};
  // const deleteCourse = (id) => {
  //   if (window.confirm("Delete this course?")) {
  //     setCourses((prev) => prev.filter((course) => course.id !== id));
  //   }
  // };
//   const addCourse = () => {

//     const title = prompt("Course Name");

//     if (!title) return;

//     const newCourse = {

//         id: Date.now(),

//         title,

//         category: "Development",

//         description: "Course Description",

//         image:
//             "https://images.unsplash.com/photo-1498050108023-c5249f4df085",

//         price: 0,

//         rating: 5,

//         students: 0,

//         duration: "8 Weeks",

//         instructor: "Unknown",

//         status: "Draft"

//     };

//     setCourses(prev => [...prev, newCourse]);

// };
const saveCourse = async () => {
  try {
    if (editingId === null) {
      // Add new course
      await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(courseForm),
      });
    } else {
      // Update existing course
      await fetch(`${API}/${editingId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...courseForm,
          id: editingId,
        }),
      });
    }

    await fetchCourses();

    setShowModal(false);
    setCourseForm(emptyCourse);
    setEditingId(null);
  } catch (err) {
    console.error("Save Error:", err);
  }
};
const deleteCourse = async (id) => {
  if (!window.confirm("Delete this course?")) return;

  try {
    await fetch(`${API}/${id}`, {
      method: "DELETE",
    });

    await fetchCourses();
  } catch (err) {
    console.error("Delete Error:", err);
  }
};
  return (
    <div className="admin_courses_layout">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div
        className={`admin_courses_main ${collapsed ? "collapsed_main" : ""}`}
      >
        {/* ================= TOPBAR ================= */}

        <div className="admin_courses_topbar" data-aos="fade-down">
          <div>
            <h1 className="admin_courses_heading">Courses</h1>

            <p className="admin_courses_subheading">
              Find all courses in one place
            </p>
          </div>

          <div className="admin_courses_topbar_right">
            {/* NOTIFICATION */}

            <div className="admin_notification">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>

                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>

              <span className="notification_dot"></span>
            </div>

            {/* ADD BUTTON */}

<button
className="admin_courses_add_btn"
onClick={()=>{
    setEditingId(null);
    setCourseForm(emptyCourse);
    setShowModal(true);
}}
>
<FiPlus/>
Add Course
</button>
          </div>
        </div>

        {/* ================= FILTERS ================= */}

        <div
          className="admin_courses_filters"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {/* SEARCH */}

          <div className="admin_courses_search">
            <FiSearch />

            <input type="text" placeholder="Search courses..." />
          </div>

          {/* SORT */}

          <button className="admin_courses_filter_btn">
            Sort by Latest
            <FiChevronDown />
          </button>

          {/* CATEGORY */}

          <button className="admin_courses_filter_btn">
            All Categories
            <FiChevronDown />
          </button>
        </div>

        {/* ================= GRID ================= */}

        <div className="admin_courses_grid">
          {courses.map((course, index) => (
            <div
              className="admin_courses_card"
              key={course.id}
              data-aos="fade-left"
              /* BIGGER STAGGER */

              data-aos-delay={index * 350}
              data-aos-duration="850"
            >
              <img
                src={course.image}
                alt={course.title}
                className="admin_courses_image"
              />

              <div className="admin_courses_card_body">
                <div className="admin_courses_card_top">
                  <span className="admin_courses_tag">{course.category}</span>

                  <div className="admin_courses_rating">
                    ★ <span>{course.rating}</span>
                  </div>
                </div>

                <h3 className="admin_courses_title">{course.title}</h3>
<p className="course_instructor">
👨‍🏫 {course.instructor}
</p>

<p className="course_duration">
⏳ {course.duration}

</p>
<p className="course_desc">
{course.description}
</p>                <div className="admin_courses_divider"></div>

                <div className="admin_courses_bottom">
                  <div className="admin_courses_students">
                    <FiUsers />

                    <span>{Number(course.students).toLocaleString()} Students</span>
                  </div>

                  <div className="admin_courses_price">₹ {course.price}</div>
                </div>

                <div className="admin_courses_actions">
<button
className="admin_courses_edit"
onClick={()=>{
    setEditingId(course.id);
    setCourseForm(course);
    setShowModal(true);
}}
>
<FiEdit2/>
Edit
</button>

<button
className="admin_courses_delete"
onClick={()=>deleteCourse(course.id)}
>
<FiTrash2/>
Delete
</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {showModal && (
  <div className="course_modal">

    <div className="course_modal_content">

      <h2>
        {editingId ? "Edit Course" : "Add Course"}
      </h2>

      <input
        type="text"
        name="title"
        placeholder="Course Name"
        value={courseForm.title}
        onChange={handleChange}
      />

      <input
        type="text"
        name="category"
        placeholder="Category"
        value={courseForm.category}
        onChange={handleChange}
      />

      <input
        type="text"
        name="image"
        placeholder="Image URL"
        value={courseForm.image}
        onChange={handleChange}
      />

      <input
        type="number"
        name="price"
        placeholder="Fees"
        value={courseForm.price}
        onChange={handleChange}
      />

      <input
        type="number"
        step="0.1"
        name="rating"
        placeholder="Rating"
        value={courseForm.rating}
        onChange={handleChange}
      />

      <input
        type="number"
        name="students"
        placeholder="Students"
        value={courseForm.students}
        onChange={handleChange}
      />

      <input
        type="text"
        name="duration"
        placeholder="Duration"
        value={courseForm.duration}
        onChange={handleChange}
      />

      <input
        type="text"
        name="instructor"
        placeholder="Instructor"
        value={courseForm.instructor}
        onChange={handleChange}
      />

      <select
        name="status"
        value={courseForm.status}
        onChange={handleChange}
      >
        <option>Published</option>
        <option>Draft</option>
      </select>

      <textarea
        rows="4"
        name="description"
        placeholder="Description"
        value={courseForm.description}
        onChange={handleChange}
      />

      <div className="course_modal_buttons">

        <button onClick={saveCourse}>
          Save Course
        </button>

        <button
          onClick={()=>{
            setShowModal(false);
            setCourseForm(emptyCourse);
          }}
        >
          Cancel
        </button>

      </div>

    </div>

  </div>
)}
      </div>
    </div>
  );
}
